import React from 'react'
import AboutFounder from '../Common/AboutFounder'
import Contact from '../Common/Contact'
import Directions from '../Common/Directions'
import Footer from '../Common/Footer'
import GoTop from '../Common/GoTop'
import OurGoals from '../Common/OurGoals'
import OurProjects from '../Common/OurProjects'
import OurTeam from '../Common/OurTeam'
import OurValues from '../Common/OurValues'
import OurVisions from '../Common/OurVisions'
import WeAre from '../Common/WeAre'
import WhoWeAre from '../Common/WhoWeAre'
import MainBanner from '../PageBanners/MainBanner'

class Home extends React.Component {
    render() {
        return (
            <React.Fragment>
                {/* Main Banner */}
                <MainBanner />
                {/* Who We Are Area */}
                <WhoWeAre />
                {/* Our visions */}
                <OurVisions />
                {/* Our values */}
                <OurValues />
                {/* We are */}
                <WeAre />
                {/* Our goals */}
                <OurGoals />
                {/* Directions */}
                <Directions />
                {/* Our team */}
                <OurTeam />
                {/* Our projects */}
                <OurProjects />
                {/* Contact Area */}
                <AboutFounder />
                <Contact />
                {/* Footer Area */}
                <Footer />
                <GoTop scrollStepInPx="50" delayInMs="16.66" />
            </React.Fragment>
        )
    }
}

export default Home